/* eslint-disable react/no-array-index-key */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, TableFooter, TablePagination } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Row from './Row';
import { fetchVendorEventsPaginated, setPaginationData } from './redux/vendorEventsActions';

export default function VendorEventsTable() {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.vendorEventsPaginated.events);
  const pagination = useSelector((state) => state.vendorEventsPaginated.pagination);

  const { page, total, count, search } = pagination;

  const handleChangeRowsPerPage = (event) => {
    const newCount = parseInt(event.target.value, 10);
    dispatch(setPaginationData({ ...pagination, count: newCount, page: 0 }));
  };
  const handleChangePage = (event, currentPage) => {
    const newPage = currentPage + 1;
    dispatch(setPaginationData({ ...pagination, page: newPage }));
  };

  const fetchData = async () => {
    await fetchVendorEventsPaginated(dispatch, { page, count, search });
  };

  useEffect(() => {
    fetchData();
  }, [page, count, search]);

  return (
    <Box sx={{ py: 4 }}>
      <TableContainer component={Paper} style={{ borderRadius: 20 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Event</TableCell>
              <TableCell align="left">Venue Name</TableCell>
              <TableCell align="left">Vendor Name</TableCell>
              <TableCell align="left">Vendor Email</TableCell>
              <TableCell align="left">Application Status</TableCell>
              <TableCell align="left">Payment Status</TableCell>
              <TableCell align="left">Event Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((row, i) => (
              <Row key={`${row.fk_vendor}-${row.fk_event}-${i}`} row={row} />
            ))}
          </TableBody>
        </Table>
        <TableFooter sx={{ display: 'flex', justifyContent: 'end' }}>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={total || 0}
              rowsPerPage={count || 10}
              page={parseInt(page, 10) - 1 || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </TableContainer>
    </Box>
  );
}
